import { BOOK_FLIGHT, DELETE_FLIGHT } from "./actionType";

export const bookFlight = (flightInfo) => {
  return {
    type: BOOK_FLIGHT,
    payload: flightInfo,
  };
};

export const deleteFlight = (id) => {
  return {
    type: DELETE_FLIGHT,
    payload: id,
  };
};
